import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { addToScope } from 'legacy/lut/features/partner360/composedReport'
import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

import { LoaderOverlay } from 'core-components/library/loader'
import { ModalDialog } from 'core-components/library/modalDialog'
import MeasureController from 'core/analytics/MeasureController'
import { SimplePartnerTable } from 'partner360/components/simplePartnerTable'

import { usePartnersSelect } from '../hooks/usePartnersSelect'

import { fetchGlobalPartnersEntities } from './api/fetchGlobalPartnersEntities'

interface IProps {
  show: boolean
  onClose: () => void
  metrics: MeasureController
}

export const GlobalEntitiesSelect = ({ show, onClose }: IProps) => {
  const [isWip, setIsWip] = useState(false)
  const dispatch = useDispatch()

  const onAddPartnersFromGlobalToScope = useCallback(
    async (global: IWWPartners) => {
      setIsWip(true)
      const partnersFromGroup = await fetchGlobalPartnersEntities(global.PartnerID)
      dispatch(addToScope(partnersFromGroup))
      setIsWip(false)
      onClose()
    },
    [dispatch, onClose]
  )

  const { partnersListProps } = usePartnersSelect({
    onClose,
    isGlobal: true,
    onRowSelect: onAddPartnersFromGlobalToScope,
    uniqSourceKey: 'global-entities',
  })

  return (
    <>
      <LoaderOverlay show={isWip} />
      <ModalDialog
        onClose={onClose}
        show={show}
        size={'lg'}
        content={SimplePartnerTable}
        contentProps={partnersListProps}
      />
    </>
  )
}
